var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "waiting",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#E9A61F",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0.127695652 C2.76208696,0.127695652 0.127695652,2.76208696 0.127695652,6 C0.127695652,9.23791304 2.76208696,11.8723043 6,11.8723043 C9.23791304,11.8723043 11.8723043,9.23791304 11.8723043,6 C11.8723043,2.76208696 9.23791304,0.127695652 6,0.127695652 Z M6,10.6983913 C3.40930435,10.6983913 1.3016087,8.59069565 1.3016087,6 C1.3016087,3.40930435 3.40930435,1.3016087 6,1.3016087 C8.59069565,1.3016087 10.6983913,3.40943478 10.6983913,6 C10.6983913,8.59056522 8.59069565,10.6983913 6,10.6983913 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "6.58695652 2.59226087 5.41304348 2.59226087 5.41304348 5.75778261 5.41304348 6.24404348 7.87173913 8.68956522 8.6996087 7.85713043 6.58695652 5.75595652"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.4bdd93cf7a2a6806726e2bbd6f24bc01.svg";
export { ForwardRef as ReactComponent };